
import { css } from 'lit';
export default css`
.text-navigation {
  display: flex;
  font-family: Lato, sans-serif;
}

  .text-navigation--footer {
  flex-direction: column;
}

  .text-navigation--footer {
  flex-wrap: wrap;
}

  .text-navigation--footer .text-navigation--item {
  margin-bottom: 2.5rem;
}

  .text-navigation--footer .text-navigation--item {
  margin-right: 1.25rem;
}

  @media (min-width: 768px) {

  .text-navigation--footer .text-navigation--item {
    margin-bottom: 2rem;
  }
}

  .text-navigation--footer .text-navigation--link {
  margin-bottom: 1rem;
}

  .text-navigation--footer .text-navigation--link {
  display: inline-block;
}

  .text-navigation--footer .text-navigation--link {
  font-size: 1.125rem;
}

  .text-navigation--footer .text-navigation--link {
  font-weight: 900;
}

  .text-navigation--footer .text-navigation--link {
  text-transform: uppercase;
}

  .text-navigation--footer .text-navigation--link {
  letter-spacing: 0.125rem;
}

  @media (min-width: 768px) {

  .text-navigation--footer .text-navigation--link {
    font-size: 1.25rem;
  }
}

  .text-navigation--footer .text-navigation--link.link--external {
        display: flex;
        align-items: center;
      }

  .text-navigation--footer .text-navigation--link.link--external .link--external__icon {
          width: 1rem;
          height: 1rem;
          margin-left: 0.5rem;
        }

  .text-navigation--footer .text-navigation--link:hover {
  text-decoration: underline;
}

  .text-navigation--footer .text-sub-navigation--link {
  display: block;
}

  .text-navigation--footer .text-sub-navigation--link {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

  .text-navigation--footer .text-sub-navigation--link {
  font-size: 1.125rem;
}

  @media (min-width: 768px) {

  .text-navigation--footer .text-sub-navigation--link {
    font-size: 1.25rem;
  }
}

  .text-navigation--footer .text-sub-navigation--link.link--external {
        display: flex;
        align-items: center;
      }

  .text-navigation--footer .text-sub-navigation--link.link--external .link--external__icon {
          width: 1rem;
          height: 1rem;
          margin-left: 0.5rem;
        }

  .text-navigation--footer .text-sub-navigation--link:hover {
  text-decoration: underline;
}

  .text-navigation--global {
  flex-direction: row;
}

  .text-navigation--global {
  align-items: flex-start;
}

  .text-navigation--global .text-navigation--item {
  display: inline-block;
}

  .text-navigation--global .text-navigation--item {
  border-right-width: 1px;
}

  .text-navigation--global .text-navigation--item {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .text-navigation--global .text-navigation--item {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

  .text-navigation--global .text-navigation--item {
  font-size: 1.25rem;
}

  .text-navigation--global .text-navigation--item {
  line-height: 1.25rem;
}

  .text-navigation--global .text-navigation--item:first-child {
  padding-left: 0px;
}

  .text-navigation--global .text-navigation--item:last-child {
  border-right-width: 0px;
}

  /* stylelint-disable-next-line no-descending-specificity*/

  .text-navigation--global .text-navigation--link {
  position: relative;
}

  .text-navigation--global .text-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .text-navigation--global .text-navigation--link:hover {
  --tw-text-opacity: 1;
  color: rgba(53, 25, 108, var(--tw-text-opacity));
}

  .text-navigation--global .text-navigation--link:hover:after {
  position: absolute;
}

  .text-navigation--global .text-navigation--link:hover:after {
  left: 0px;
}

  .text-navigation--global .text-navigation--link:hover:after {
  right: 0px;
}

  .text-navigation--global .text-navigation--link:hover:after {
  height: 3px;
}

  .text-navigation--global .text-navigation--link:hover:after {
  width: 100%;
}

  .text-navigation--global .text-navigation--link:hover:after {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

  .text-navigation--global .text-navigation--link:hover:after {
        bottom: -20px;
        content: '';
      }

  .text-navigation--global .active {
  font-weight: 900;
}

  .text-navigation--global .active:after {
  position: absolute;
}

  .text-navigation--global .active:after {
  left: 0px;
}

  .text-navigation--global .active:after {
  right: 0px;
}

  .text-navigation--global .active:after {
  height: 3px;
}

  .text-navigation--global .active:after {
  width: 100%;
}

  .text-navigation--global .active:after {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .text-navigation--global .active:after {
        bottom: -20px;
        content: '';
      }

  .text-navigation--global .active:hover:after {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

  .text-navigation--legal {
  flex-grow: 1;
}

  .text-navigation--legal {
  flex-wrap: wrap;
}

  .text-navigation--legal {
  justify-content: flex-start;
}

  .text-navigation--legal {
  font-size: 0.875rem;
}

  @media (min-width: 768px) {

  .text-navigation--legal {
    justify-content: space-between;
  }
}

  @media (min-width: 768px) {

  .text-navigation--legal {
    font-size: 1rem;
  }
}

  /* stylelint-disable-next-line no-descending-specificity*/

  .text-navigation--legal .text-navigation--link {
  display: block;
}

  .text-navigation--legal .text-navigation--link {
  padding-bottom: 1rem;
}

  .text-navigation--legal .text-navigation--link {
      padding-right: 13px;
    }

  @media (min-width: 768px) {

  .text-navigation--legal .text-navigation--link {
        padding-right: 30px
    }
      }

  .text-navigation--legal .text-navigation--link:hover {
  text-decoration: underline;
}

  .text-navigation--hp .text-navigation--item .text-navigation--link {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .text-navigation--hp .text-navigation--item .text-navigation--link:hover:after {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 254, 254, var(--tw-bg-opacity));
}

  .text-navigation--hp .text-navigation--item .active:after {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .text-navigation--hp .text-navigation--item .active:hover:after {
  --tw-bg-opacity: 1;
  background-color: rgba(254, 254, 254, var(--tw-bg-opacity));
}
`;